<template>
	<Layout class="HomePc">
		<nav class="nav"/>
		<button @click="navToIfreeGroupPage" class="faq fs16 fw700">
			<svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
				<mask id="path-2-inside-1" fill="white">
					<path fill-rule="evenodd" clip-rule="evenodd"
						  d="M34.5275 26.5373C35.4744 24.3838 36 22.0033 36 19.5C36 9.83502 28.165 2 18.5 2C8.83502 2 1 9.83502 1 19.5C1 29.165 8.83502 37 18.5 37C21.7682 37 24.8272 36.1041 27.4447 34.5445L36.2743 35.4274C36.6238 35.4624 36.8995 35.1355 36.8061 34.7969L34.5275 26.5373Z"/>
				</mask>
				<path
					d="M34.5275 26.5373L31.7813 25.3297L31.3518 26.3065L31.6355 27.335L34.5275 26.5373ZM27.4447 34.5445L27.7433 31.5594L26.759 31.4609L25.9092 31.9673L27.4447 34.5445ZM36.2743 35.4274L36.5728 32.4423L36.5728 32.4423L36.2743 35.4274ZM36.8061 34.7969L33.9141 35.5947L33.9141 35.5947L36.8061 34.7969ZM33 19.5C33 21.5797 32.564 23.5496 31.7813 25.3297L37.2738 27.7448C38.3848 25.218 39 22.4269 39 19.5H33ZM18.5 5C26.5081 5 33 11.4919 33 19.5H39C39 8.17816 29.8218 -0.999997 18.5 -0.999997V5ZM4 19.5C4 11.4919 10.4919 5 18.5 5V-0.999997C7.17816 -0.999997 -2 8.17816 -2 19.5H4ZM18.5 34C10.4919 34 4 27.5081 4 19.5H-2C-2 30.8218 7.17816 40 18.5 40V34ZM25.9092 31.9673C23.7432 33.2579 21.2128 34 18.5 34V40C22.3236 40 25.9113 38.9503 28.9803 37.1217L25.9092 31.9673ZM36.5728 32.4423L27.7433 31.5594L27.1462 37.5296L35.9758 38.4125L36.5728 32.4423ZM33.9141 35.5947C33.447 33.9018 34.8253 32.2676 36.5728 32.4423L35.9758 38.4125C38.4223 38.6572 40.3519 36.3693 39.698 33.9992L33.9141 35.5947ZM31.6355 27.335L33.9141 35.5947L39.698 33.9992L37.4195 25.7395L31.6355 27.335Z"
					fill="white" mask="url(#path-2-inside-1)"/>
				<path
					d="M18.7685 10.5278C16.9925 10.5278 15.6005 11.0318 14.5685 12.0398C13.5125 13.0478 13.0085 14.4398 13.0085 16.2158H15.7445C15.7445 15.1838 15.9365 14.3918 16.3445 13.8398C16.8245 13.1918 17.5685 12.8798 18.6005 12.8798C19.4165 12.8798 20.0645 13.0958 20.5205 13.5518C20.9525 14.0078 21.1925 14.6318 21.1925 15.4238C21.1925 16.0238 20.9765 16.5998 20.5445 17.1278L20.2565 17.4638C18.6965 18.8558 17.7605 19.8638 17.4485 20.5118C17.1125 21.1598 16.9685 21.9518 16.9685 22.8638H19.7285C19.7285 22.2878 19.8485 21.7598 20.0885 21.2798C20.3045 20.8478 20.6165 20.4398 21.0485 20.1038C22.2005 19.0958 22.8965 18.4478 23.1125 18.2078C23.6885 17.4398 24.0005 16.4558 24.0005 15.2558C24.0005 13.7918 23.5205 12.6398 22.5605 11.7998C21.6005 10.9358 20.3285 10.5278 18.7685 10.5278ZM18.3365 24.3758C17.8085 24.3758 17.3765 24.5438 17.0405 24.8798C16.6565 25.2158 16.4885 25.6478 16.4885 26.1758C16.4885 26.7038 16.6565 27.1358 17.0405 27.4718C17.3765 27.8078 17.8085 27.9998 18.3365 27.9998C18.8645 27.9998 19.2965 27.8318 19.6805 27.4958C20.0165 27.1598 20.2085 26.7038 20.2085 26.1758C20.2085 25.6478 20.0165 25.2158 19.6805 24.8798C19.3205 24.5438 18.8645 24.3758 18.3365 24.3758Z"
					fill="white"/>
			</svg>
		</button>
		<a class="to-top fs16 fw700" href="#">
			<svg width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M3 16L15 5L27 16" stroke="white" stroke-width="4"/>
			</svg>
		</a>
		<section class="floor0">
			<div class="shine-1 anim-shine">
				<div class="shine-point"></div>
			</div>
			<div class="shine-2 anim-shine-2">
				<div class="shine-point"></div>
			</div>
			<div class="shine-3 anim-shine">
				<div class="shine-point"></div>
			</div>
			<div class="content">
				<img class="w360" v-if="this.$i18n.locale==='zh-CN'" src="../../../src/assets/imgs/home/phone&t1.png"
					 alt="">
				<img class="w360" v-if="this.$i18n.locale==='en-US'" src="../../../src/assets/imgs/home/phone&t1_en.png"
					 alt="">
				<div class="right fs24 lh1x2">
					<img v-if="this.$i18n.locale==='en-US'" class="pb24" style="width: 330px;"
						 src="../../../src/assets/imgs/home/MOGO_T1.png" alt="">
					<img v-if="this.$i18n.locale==='zh-CN'" class="pb24" style="width: 260px;"
						 src="../../../src/assets/imgs/home/MOGO_T1.png" alt="">
					<div class="w400" v-html="$t('header_slogon_1')"></div>
					<div class="w400" v-html="$t('header_slogon_2')"></div>
					<div id="product-component-1595415704699" class="buy-button"></div>
				</div>
			</div>
		</section>
		<div class="video-section">
			<iframe class="video-tracker" width="800" height="450"
					src="https://www.youtube-nocookie.com/embed/RI_NjVIIrYM" frameborder="0"
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen></iframe>
		</div>
		<section class="floor1">
			<div class="max-w800">
				<div class="pb24 fs50 lh1x2 fw700 pb24" v-html="$t('global_title')"></div>
				<div class="fs18 mb40">{{ $t('global_text') }}</div>
			</div>
			<img ref="earthImg" id="earthImg" src="../../../src/assets/imgs/home/earth.png" alt="">
		</section>
		<section class="floor2">
			<img ref="gpsBgImg" class="gps-bg" v-if="this.$i18n.locale==='zh-CN'"
				 src="../../../src/assets/imgs/home/GPS_bg.png" alt="">
			<img ref="gpsBgImg" class="gps-bg" v-if="this.$i18n.locale==='en-US'"
				 src="../../../src/assets/imgs/home/GPS_bg_en.png" alt="">
			<div class="right">
				<div class="fs50 lh1x2 fw700 pb16 mb32" v-html="$t('locate_title')"></div>
				<img src="../../../src/assets/imgs/home/satellite.jpg" alt="" class="picBorderRadius">
			</div>
		</section>
		<section class="floor3">
			<div class="left">
				<div class="w540 fs50 lh1x2 fw700 pb16" v-html="$t('bluetooth_title')"></div>
				<div class="w540 fs18 pb40">{{ $t('bluetooth_text') }}</div>
				<img src="../../../src/assets/imgs/home/bluetooth.jpg" alt="" class="picBorderRadius">
			</div>
		</section>
		<section class="floor4">
			<div class="max-w800">
				<div class="fs50 lh1x2 fw700 pb24" v-html="$t('alert_title')"></div>
				<div class="max-w800 fs18">{{ $t('alert_text') }}</div>
			</div>
		</section>
		<ScreenIntersectionObserver class="floor5" :adapter="adapter" :crossScreenPositionY="700">
			<template v-slot:default="{distance}">
				<img ref="designTopImg" src="../../../src/assets/imgs/home/design_top.png"
					 :style="{transform:`translateY(${distance}px)`}" alt="" class="top">
				<div class="text mt280 max-w480">
					<div class="fs50 pb16 lh1x2 fw700" v-html="$t('design_title')"></div>
					<div class="fs18">{{ $t('design_text') }}</div>
				</div>
				<img ref="designBottomImg" src="../../../src/assets/imgs/home/design_bottom.png" alt=""
					 class="bottom" :style="{transform:`translateY(${-distance}px)`,paddingTop:'260px'}">
			</template>
		</ScreenIntersectionObserver>
		<section class="floor6">
			<img src="../../../src/assets/imgs/home/spec.png"
				 class="left"
				 alt="">
			<!-- <span class="fs40 fw700">产品参数</span> -->
			<img v-if="this.$i18n.locale==='zh-CN'"
				 src="../../../src/assets/imgs/home/spec_detail.jpg"
				 class="spec-details right"
				 alt="">
			<img v-if="this.$i18n.locale==='en-US'"
				 src="../../../src/assets/imgs/home/spec_detail_en.jpg"
				 class="spec-details-en right"
				 alt="">
		</section>
		<section class="floor7">
			<h3 class="title">{{ $t('coverage') }}</h3>
			<table class="region-table">
				<tr v-for="rowName in Object.keys(_coverageRegionTable)" :key="rowName">
					<td v-for="(rowVal,index) in _coverageRegionTable[rowName]" :key="index">{{rowVal.countryName}}</td>
				</tr>
			</table>
		</section>
		<section class="floor8">
			<div class="content">
				<div class="app-title pb40 max-w700">
					<div class="fs40 lh1x4 fw700 pb16" v-html="$t('app_title')"></div>
					<div class="fs18">{{ $t('app_text')}}</div>
				</div>
				<div class="content-bot">
					<div class="bot-left">
						<div class="describe">
							<div class="slide-icon">
								<img class="slide-ico-size" v-if="activeIndex===0"
									 src="../../assets/imgs/home/ic_map.png"
									 alt="">
								<img class="slide-ico-size" v-if="activeIndex===1"
									 src="../../assets/imgs/home/ic_region.png"
									 alt="">
								<img class="slide-ico-size" v-if="activeIndex===2"
									 src="../../assets/imgs/home/ic_share.png"
									 alt="">
								<img class="slide-ico-size" v-if="activeIndex===3"
									 src="../../assets/imgs/home/ic_locate.png"
									 alt="">
								<img class="slide-ico-size" v-if="activeIndex===4"
									 src="../../assets/imgs/home/ic_alert.png"
									 alt="">
							</div>
							<div class="fs26 lh1x2 fw700 pb8" v-if="activeIndex===0"
								 v-html="$t('app_slide_title_0')"></div>
							<div class="fs18" v-if="activeIndex===0" v-html="$t('app_slide_text_0')"></div>
							<div class="fs26 lh1x2 fw700 pb8" v-if="activeIndex===1"
								 v-html="$t('app_slide_title_1')"></div>
							<div class="fs18" v-if="activeIndex===1" v-html="$t('app_slide_text_1')"></div>
							<div class="fs26 lh1x2 fw700 pb8" v-if="activeIndex===2"
								 v-html="$t('app_slide_title_2')"></div>
							<div class="fs18" v-if="activeIndex===2">{{ $t('app_slide_text_2') }}</div>
							<div class="fs26 lh1x2 fw700 pb8" v-if="activeIndex===3"
								 v-html="$t('app_slide_title_3')"></div>
							<div class="fs18" v-if="activeIndex===3">{{ $t('app_slide_text_3') }}</div>
							<div class="fs26 lh1x2 fw700 pb8" v-if="activeIndex===4"
								 v-html="$t('app_slide_title_4')"></div>
							<div class="fs18" v-if="activeIndex===4">
								<div class="text-slide-4">
									<div class="pr4" v-if="activeIndex===4">•</div>
									<div v-if="activeIndex===4">{{ $t('app_slide_text_4_1') }}</div>
								</div>
								<div class="text-slide-4 pt8">
									<div class="pr4" v-if="activeIndex===4">•</div>
									<div v-if="activeIndex===4">{{ $t('app_slide_text_4_2') }}</div>
								</div>
							</div>
						</div>
						<div class="download">
							<img src="../../../src/assets/imgs/home/qrcode.png" alt="">
							<div class="tag-store">
								<img src="../../../src/assets/imgs/home/app_store.png" alt="" class="w120 pb4">
								<img src="../../../src/assets/imgs/home/play_store.png" alt="" class="w120">
							</div>
						</div>
					</div>
					<div class="bot-right">
						<div class="mockup-in-shadow-1">
							<div class="mockup-in-shadow-2">
								<div class="mockup"></div>
							</div>
						</div>
						<div class="swiper-container" ref="pcSwiperWrapper">
							<div class="swiper-wrapper">
								<!-- Slides -->
								<template v-if="$i18n.locale==='zh-CN'">
									<img
										class="swiper-slide"
										src="../../../src/assets/imgs/home/slide_0.jpg" key="zh-CN1">
									<img
										class="swiper-slide"
										src="../../../src/assets/imgs/home/slide_1.jpg" key="zh-CN2">
									<img
										class="swiper-slide"
										src="../../../src/assets/imgs/home/slide_2.jpg" key="zh-CN3">
									<img
										class="swiper-slide"
										src="../../../src/assets/imgs/home/slide_3.jpg" key="zh-CN4">
									<img
										class="swiper-slide"
										src="../../../src/assets/imgs/home/slide_4.jpg" key="zh-CN5">
								</template>
								<template v-else-if="$i18n.locale==='en-US'">
									<img
										class="swiper-slide"
										src="../../../src/assets/imgs/home/slide_0_en.jpg" key="en-US1">
									<img
										class="swiper-slide"
										src="../../../src/assets/imgs/home/slide_1_en.jpg" key="en-US2">
									<img
										class="swiper-slide"
										src="../../../src/assets/imgs/home/slide_2_en.jpg" key="en-US3">
									<img
										class="swiper-slide"
										src="../../../src/assets/imgs/home/slide_3_en.jpg" key="en-US4">
									<img
										class="swiper-slide"
										src="../../../src/assets/imgs/home/slide_4_en.jpg" key="en-US5">
								</template>
							</div>
						</div>
						<div class="swiper-btn">
							<div class="swiper-button-prev"></div>
							<div class="swiper-pagination"></div>
							<div class="swiper-button-next"></div>
						</div>
					</div>
				</div>
			</div>
		</section>
 <div :class="['coupon',couponVisibale?'coupon-show':couponFirstVisibale?'coupon-first-show':'coupon-hidden']">
			<a @click="clickCouponHandle" href="https://store.ifreegroup.com/collections/mogo/products/mogo-t1"
			   target="_blank">
				<img v-if="this.$i18n.locale==='en-US'" src="../../../src/assets/imgs/home/coupon_t1_en.png" alt="" style="width: 203px; height: 288px;">
				<img v-if="this.$i18n.locale==='zh-CN'" src="../../../src/assets/imgs/home/coupon_t1_cn.png" alt="" style="width: 203px; height: 288px;">
			</a>
		</div>
	</Layout>
</template>


<script>
	(function () {
		const scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
		if (window.ShopifyBuy) {
			if (window.ShopifyBuy.UI) {
				ShopifyBuyInit();
			} else {
				loadScript();
			}
		} else {
			loadScript();
		}

		function loadScript() {
			var script = document.createElement('script');
			script.async = true;
			script.src = scriptURL;
			(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
			script.onload = ShopifyBuyInit;
		}

		function ShopifyBuyInit() {
			// eslint-disable-next-line no-undef
			var client = ShopifyBuy.buildClient({
				domain: 'ifree-store.myshopify.com',
				storefrontAccessToken: 'b570275f91a1ef4970a0bffc19e9a292',
			});
			// eslint-disable-next-line no-undef
			ShopifyBuy.UI.onReady(client).then(function (ui) {
				ui.createComponent('product', {
					id: '4733696016519',
					node: document.getElementById('product-component-1595415704699'),
					moneyFormat: '%24%7B%7Bamount%7D%7D',
					options: {
						'product': {
							'styles': {
								'product': {
									'@media (min-width: 601px)': {
										'max-width': 'calc(25% - 20px)',
										'margin-left': '20px',
										'margin-bottom': '50px'
									}
								},
								'title': {
									'font-family': 'Montserrat, sans-serif'
								},
								'button': {
									'font-family': 'Montserrat, sans-serif',
									'font-weight': 'bold',
									':hover': {
										'background-color': '#1150af'
									},
									'background-color': '#1359c2',
									':focus': {
										'background-color': '#1150af'
									},
									'border-radius': '6px'
								},
								'price': {
									'font-family': 'Montserrat, sans-serif'
								},
								'compareAt': {
									'font-family': 'Montserrat, sans-serif'
								},
								'unitPrice': {
									'font-family': 'Montserrat, sans-serif'
								}
							},
							'buttonDestination': 'checkout',
							'contents': {
								'img': false,
								'title': false,
								'price': false
							},
							'text': {
								'button': 'Buy now'
							},
							'googleFonts': [
								'Montserrat'
							]
						},
						'productSet': {
							'styles': {
								'products': {
									'@media (min-width: 601px)': {
										'margin-left': '-20px'
									}
								}
							}
						},
						'modalProduct': {
							'contents': {
								'img': false,
								'imgWithCarousel': true,
								'button': false,
								'buttonWithQuantity': true
							},
							'styles': {
								'product': {
									'@media (min-width: 601px)': {
										'max-width': '100%',
										'margin-left': '0px',
										'margin-bottom': '0px'
									}
								},
								'button': {
									'font-family': 'Montserrat, sans-serif',
									'font-weight': 'bold',
									':hover': {
										'background-color': '#1150af'
									},
									'background-color': '#1359c2',
									':focus': {
										'background-color': '#1150af'
									},
									'border-radius': '6px'
								}
							},
							'googleFonts': [
								'Montserrat'
							],
							'text': {
								'button': 'Add to cart'
							}
						},
						'cart': {
							'styles': {
								'button': {
									'font-family': 'Montserrat, sans-serif',
									'font-weight': 'bold',
									':hover': {
										'background-color': '#1150af'
									},
									'background-color': '#1359c2',
									':focus': {
										'background-color': '#1150af'
									},
									'border-radius': '6px'
								}
							},
							'text': {
								'total': 'Subtotal',
								'button': 'Checkout'
							},
							'googleFonts': [
								'Montserrat'
							]
						},
						'toggle': {
							'styles': {
								'toggle': {
									'font-family': 'Montserrat, sans-serif',
									'font-weight': 'bold',
									'background-color': '#1359c2',
									':hover': {
										'background-color': '#1150af'
									},
									':focus': {
										'background-color': '#1150af'
									}
								}
							},
							'googleFonts': [
								'Montserrat'
							]
						}
					},
				});
			});
		}
	})();

	import Swiper from 'swiper';
	import ScreenIntersectionObserver from '@/components/ScreenIntersectionObserver';
	import BezierEasing from 'bezier-easing';
	import {fetchCoverageRegionApi} from '@/api/common';
	import {exchangeListToTable} from '@/views/Home/apiDataConversion';
	import Header from '@/components/common/Header/Index.vue';
	import copy from 'copy-to-clipboard';

	const easing = BezierEasing(0.27, 0.04, 0.40, 0.62);
	export default {
		components: {
			ScreenIntersectionObserver,
		},
		data() {
			return {
				activeIndex: 0,
				coverageRegionList: [],
				couponVisibale: false,
				couponFirstVisibale: false,
				showNavBar: true,
			};
		},
		mounted() {
			// 取消浏览器记录滚动条位置
			if (history.scrollRestoration) {
				history.scrollRestoration = 'manual';
			}
			this.fetchCoverageRegion();
			this.initSwiper();
			window.addEventListener('scroll',this.onScrolling);
			this.initIntersectionObserver();
		},
		methods: {
			clickCouponHandle(e){
				if(!this.couponVisibale){
					e.preventDefault();
					this.couponVisibale = true;this.couponFirstVisibale = true;
				}
				copy('T1PROMO20');
			},
			navToIfreeGroupPage() {
				// https://faq.ifreegroup.cn/?type=tracker&lang=$_lang
				// window.location.href = `https://faq.ifreegroup.cn/?type=tracker&lang=${this.$i18n.locale}`;
				window.open(`https://faq.ifreegroup.cn/?type=tracker&lang=${this.$i18n.locale}`);
			},
			async fetchCoverageRegion() {
				const {data} = await fetchCoverageRegionApi();
				this.coverageRegionList = data;
			},
			onScrolling(e){
				let scrollTop = document.documentElement.scrollTop;
				let targetHeight = 3150;
				if(scrollTop >= targetHeight && scrollTop <= (targetHeight + 120)){
					this.couponFirstVisibale = true;
					this.couponVisibale = true;
				}else{
					this.couponVisibale = false;
				}
				// 当前为向上方向
				let isUpDirect = (Number(this.lastPostiionYVal) - scrollTop) > 0 ;
				if(isUpDirect){
					this.showNavBar = true;
				}else{
					if(scrollTop >= 300){
						this.showNavBar = false;
					}else{
						this.showNavBar = true;
					}
				}
				this.lastPostiionYVal = scrollTop;

			},
			initIntersectionObserver() {
				const iov = new IntersectionObserver((entries) => {
					entries.forEach(item => {
						if (item.isIntersecting) {
							if (item.target === this.$refs.earthImg) {
								item.target.classList.add('animated', 'slideInUp');
							} else if (item.target === this.$refs.gpsBgImg) {
								item.target.classList.add('animated', 'slideInUp');
							}
						}
					});
				});
				// 添加被观察的对象
				[
					this.$refs.earthImg,
					this.$refs.gpsBgImg,
				].forEach(item => {
					iov.observe(item);
				});
			},
			initSwiper() {
				const that = this;
				new Swiper(this.$refs.pcSwiperWrapper, {
					autoplay: {
						delay: 3000,
						stopOnLastSlide: false,
						disableOnInteraction: true,
					},
					loop: true,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					pagination: {
						el: '.swiper-pagination',
					},
					on: {
						slideChange: function () {
							// https://github.com/nolimits4web/swiper/issues/2629#issuecomment-527504478
							if (that.swiper) {
								that.swiper.loopDestroy();
								that.swiper.loopCreate();
							}
							that.activeIndex = this.realIndex;
						},
					},
				});
			},
			designTopImgAdapter({distance}) {
				return distance * 0.8;
			},
			designBottomImgAdapter({eleHeight, distance}) {
				return easing(distance / eleHeight) * distance;
			}
		},
		computed: {
			_coverageRegionTable() {
				return exchangeListToTable(this.$i18n.locale, this.coverageRegionList, 2);
			}
		},
		destroyed(){
			window.removeEventListener('scroll',this.onScrolling);
		}
	};
</script>


<style>
	.swiper-pagination-bullet, .swiper-pagination-bullet-active {
		margin-right: 2px;
		margin-left: 2px;
	}

	.anim-control {
		animation-duration: 2s;
		animation-delay: 1s;
	}

	@-webkit-keyframes slideInUp {
		from {
			-webkit-transform: translate3d(0, 100%, 0);
			transform: translate3d(0, 100%, 0);
			opacity: 0;
		}

		to {
			-webkit-transform: translate3d(0, 0, 0);
			transform: translate3d(0, 0, 0);
			opacity: 1;
		}
	}

	@keyframes slideInUp {
		from {
			-webkit-transform: translate3d(0, 100%, 0);
			transform: translate3d(0, 100%, 0);
			opacity: 0;
		}

		to {
			-webkit-transform: translate3d(0, 0, 0);
			transform: translate3d(0, 0, 0);
			opacity: 1;
		}
	}

	.slideInUp {
		-webkit-animation-name: slideInUp;
		animation-name: slideInUp;
		animation-delay: 200ms;
		animation-duration: 1500ms;
	}

	.slideInLeft {
		-webkit-animation-name: slideInLeft;
		animation-name: slideInLeft;
		animation-duration: 2400ms;
		animation-delay: 100ms;
	}

	.slideInDown {
		-webkit-animation-name: slideInDown;
		animation-name: slideInDown;
		animation-delay: 1000ms;
		animation-duration: 1600ms;
	}

	body {
		line-height: 240%;
	}

</style>
<style lang="scss" scoped>

	.HomePc {
		min-width: 1200px;
	}

	.to-top {
		position: fixed;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 56px;
		height: 56px;
		border-radius: 80px;
		bottom: 88px;
		right: 24px;
		z-index: 999;
		background: linear-gradient(to bottom, #1A77FF, #47CCFF);
		color: white;
		/*box-shadow: 0 14px 18px rgba(130, 210, 255, .5);*/
		&:hover {
			width: 56px;
			height: 56px;
			background: linear-gradient(to bottom, #1a6eff, #47c2ff);
			color: white;
		}
	}

	.faq {
		position: fixed;
		bottom: 164px;
		right: 24px;
		width: 56px;
		height: 56px;
		border-radius: 80px;
		z-index: 999;
		background: linear-gradient(to bottom, #1A77FF, #47CCFF);
		color: white;
		/*box-shadow: 0 14px 18px rgba(130, 210, 255, .5);*/
		&:hover {
			width: 56px;
			height: 56px;
			background: linear-gradient(to bottom, #1a6eff, #47c2ff);
			color: white;
		}
	}

	.coupon {
		position: fixed;
		top: 100px;
		transition: left 500ms;
	}

	.coupon:hover {
		left: 0;
	}

	.coupon-show {
		left: 0;
	}

	.coupon-first-show {
		left: -180px;
	}

	.coupon-hidden {
		left: -210px;
	}



	.picBorderRadius {
		border-radius: 12px;
	}

	.lh1x2 {
		line-height: 120%;
	}

	.lh1x4 {
		line-height: 140%;
	}

	.w120 {
		width: 120px;
	}

	.w360 {
		width: 360px;
	}

	.w400 {
		width: 400px;
	}

	.w540 {
		width: 540px;
	}

	.max-w480 {
		max-width: 480px;
	}

	.max-w700 {
		max-width: 700px;
	}

	.max-w800 {
		max-width: 800px;
	}

	.mt280 {
		margin-top: 280px;
	}

	.floor0, .floor1, .floor3, .floor4, .floor5, .floor6 {
		color: #fff;
	}

	.floor0 {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 960px;
		background: url("../../../src/assets/imgs/home/header_bg.jpg") 50% no-repeat;
		background-size: cover;

		.buy-button {
			margin-top: 20px;
			margin-left: -60px;
		}

		.shine-1 {
			position: absolute;
			top: 5%;
			left: 16%;
			box-shadow: 0 0 12px #00BFFF;
		}

		.shine-2 {
			position: absolute;
			bottom: 55%;
			right: 8%;
			box-shadow: 0 0 12px #00BFFF;
		}

		.shine-3 {
			position: absolute;
			bottom: 20%;
			right: 18%;
			box-shadow: 0 0 12px #00BFFF;
		}

		.shine-point {
			width: 5px;
			height: 5px;
			border-radius: 6px;
			background: #00BFFF;
			box-shadow: 0 0 12px 1px #00BFFF;
		}


		.anim-shine {
			animation: 2s shine 0s infinite;
			-webkit-animation: 2s shine 0s infinite;
			-moz-animation: 2s shine 0s infinite;
			@keyframes shine {
				0% {
					opacity: 0
				}
				40% {
					opacity: .8;
				}
				60% {
					opacity: .8;
				}
				100% {
					opacity: 0;
				}
			}
			@-webkit-keyframes shine {
				0% {
					opacity: 0
				}
				40% {
					opacity: .8;
				}
				60% {
					opacity: .8;
				}
				100% {
					opacity: 0;
				}
			}

			@-moz-keyframes shine {
				0% {
					opacity: 0
				}
				40% {
					opacity: .8;
				}
				60% {
					opacity: .8;
				}
				100% {
					opacity: 0;
				}
			}
		}

		.anim-shine-2 {
			animation: 2s shine 1s infinite;
			-webkit-animation: 2s shine 1s infinite;
			-moz-animation: 2s shine 1s infinite;
			@keyframes shine {
				0% {
					opacity: 0
				}
				40% {
					opacity: .8;
				}
				60% {
					opacity: .8;
				}
				100% {
					opacity: 0;
				}
			}
			@-webkit-keyframes shine {
				0% {
					opacity: 0
				}
				40% {
					opacity: .8;
				}
				60% {
					opacity: .8;
				}
				100% {
					opacity: 0;
				}
			}

			@-moz-keyframes shine {
				0% {
					opacity: 0
				}
				40% {
					opacity: .8;
				}
				60% {
					opacity: .8;
				}
				100% {
					opacity: 0;
				}
			}
		}

		.content {
			display: flex;
			align-items: center;
			justify-content: center;

			.right {
				text-align: left;
				padding-left: 64px;

				.logo-t1 {
					width: 320px;

					img {
						width: 320px;
					}
				}
			}
		}
	}

	.video-section {
		background-color: black;

		.video-tracker {
			border-radius: 12px;
		}
	}

	.floor1 {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 960px;
		background-color: #000;
		overflow: hidden;
	}

	.floor2 {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		height: 960px;
		background-color: #fff;
		overflow: hidden;

		.gps-bg {
			margin-top: 400px;
			height: 1100px;
		}

		.right {
			text-align: right;
			margin-right: 18%;
		}
	}

	.floor3 {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		height: 960px;
		background: url("../../../src/assets/imgs/home/bluetooth_bg.jpg") 50% no-repeat;
		background-size: cover;

		.left {
			text-align: left;
			padding-left: 18%;
		}
	}

	.floor4 {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 960px;
		background: url("../../../src/assets/imgs/home/family.jpg") 50% no-repeat;
		background-size: cover;
	}

	.floor5 {
		height: 960px;
		width: 1200px;
		overflow: hidden;
		position: relative;
		display: block;
		margin: auto;

		.top {
			position: absolute;
			left: 0;
			top: -380px;
			/*transform: translateY(264px);*/
		}

		.text {
			text-align: left;
			margin-left: 28%;
		}

		.bottom {
			position: absolute;
			bottom: -300px;
			right: 0;
		}
	}

	.floor6 {
		.left {
			margin-right: 80px;
			vertical-align: middle;
			margin-top: 20px;
		}

		.spec-details {
			margin-top: 20px;
			height: 560px;
			width: 500px;
			vertical-align: middle;
		}

		.spec-details-en {
			margin-top: 20px;
			height: 600px;
			width: 600px;
			vertical-align: middle;
		}
	}

	.floor7 {
		width: 1200px;
		margin: 88px auto;

		.title {
			font-style: normal;
			font-weight: 600;
			font-size: 40px;
			line-height: 56px;
			color: #FFFFFF;
			text-align: start;
		}

		.region-table {
			width: 100%;
			box-sizing: border-box;
			margin: 24px 0;

			td {
				font-size: 18px;
				line-height: 25px;
				color: #FFFFFF;
				text-align: left;
				padding: 6px;
			}
		}
	}

	.floor8 {
		height: 960px;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background: url("../../../src/assets/imgs/home/mtrack.jpg") 50% no-repeat;
		background-size: cover;

		.content {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}

		.content-bot {
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.bot-left {
			display: flex;
			flex-direction: column;
			text-align: left;
			justify-content: space-between;
			width: 270px;
			min-height: 400px;
			margin-right: 40px;
			margin-left: 40px;
			margin-bottom: 44px;

			.describe {
				display: flex;
				flex-direction: column;
				min-height: 280px;
			}

			.text-slide-4 {
				display: flex;
			}

			.slide-icon {
				margin-left: -6px;

				.slide-ico-size {
					width: 64px;
				}
			}

			.download {
				display: flex;
				align-items: center;
				margin-top: 24px;
				padding-right: 16px;

				.tag-store {
					display: flex;
					flex-direction: column;
					padding-left: 16px;
				}
			}
		}

		.bot-right {
			position: relative;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.mockup-in-shadow-1 {
				background: linear-gradient(to right, #f0f0f0, #f5f5f5);
				border-radius: 18px;
				box-shadow: 12px 14px 23px rgba(0, 0, 0, 0.1);

				.mockup-in-shadow-2 {
					border-radius: 18px;
					box-shadow: inset -1px -1px 5px rgba(0, 0, 0, 0.1);

					.mockup {
						width: 250px;
						height: 512px;
						border-radius: 18px;
						box-shadow: inset 3px 4px 4px #fff;
					}

				}
			}

			.swiper-container {
				position: absolute;
				top: 10px;
				left: 12px;
				height: 490px;
				width: 225px;
				border-radius: 12px;
				overflow: hidden;
				box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
			}

			.swiper-btn {
				display: flex;
				justify-content: space-between;
				align-items: center;
				width: 200px;
				margin-top: 24px;
				// --swiper-theme-color: #fff;/* 设置Swiper风格 */
				--swiper-navigation-color: #fff; /* 单独设置按钮颜色 */
				--swiper-navigation-size: 10px; /* 设置按钮大小 */
				:focus {
					-webkit-tap-highlight-color: rgba(255, 255, 255, 0);
					outline: none;
				}

				.swiper-button-prev {
					position: relative;
					height: 22px;
					width: 34px;
					background-color: #ccc;
					border-radius: 6px;
				}

				.swiper-pagination {
					position: relative;
				}

				/*.swiper-pagination-bullet, swiper-pagination-bullet-active {*/
				/*	margin-left: 4px;*/
				/*	margin-right: 4px;*/
				/*}*/

				.swiper-button-next {
					position: relative;
					height: 22px;
					width: 34px;
					background-color: #ccc;
					border-radius: 6px;
				}
			}
		}
	}
</style>
